import { render, staticRenderFns } from "./driver-detail-deja.vue?vue&type=template&id=b62ab3f4"
import script from "./driver-detail-deja.vue?vue&type=script&lang=js"
export * from "./driver-detail-deja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports